<template>
  <div>
    <router-link v-for="data in data" :key="data.id" tag="div" class="border-bottom card-wrap" :to="(data.type == 1?'/play/'+data.id+'/'+data.video_ids:'/systematic/'+data.id)">
      <div class="left">
        <img v-lazy="data.image" alt="">
      </div>
      <div class="right">
        <div class="title">
          <span v-html="data.title"><!-- 标题 --></span>
          <template v-if="type === 'collect'">
            <span class="browser">{{data.browses}}人在看</span>
          </template>
          <!-- 已购 或者 限免 -->
          <template v-else>
            <span v-if="data.complete !== 'complete'" class="browser">已播{{data.complete}}分钟</span>
            <span v-else-if="data.cert" class="browser cert" @click.prevent.stop="go(data.cert)">查看证书</span>
            <span v-else class="browser">已播完</span>
          </template>
        </div>
        <div class="teacher" v-html="data.user_name"></div>
        <div class="label">
          <span v-if="data.section&&data.type===2">{{data.section}}节</span>
          <span v-if="data.istop">精品课程</span>
        </div>
        <template v-if="type === 'collect'">
          <div class="countdown">{{data.promotion_name}} {{data.remaining}}</div>
        </template>
        <template v-if="type === 'limitfree'">
          <div class="countdown">{{data.remaining}}</div>
        </template>
        <!-- 买了的没有价格了,只有收藏有价格 -->
        <div class="price" v-if="type==='collect'">
          <span class="origin" v-if="data.is_promotion">￥<s>{{data.price}}</s></span>
          <span class="now"><span>￥</span>{{data.is_promotion ?data.promotion_price:data.price}}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import {getRemaining} from '@/utils/dateUtil'
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return []
      }
    },
    type: {
      type: String // 什么列表 , bought 购买列表, limitfree 限时免费, collect 收藏列表
    }
  },
  data() {
    return {
      timer: null
    }
  },
  computed: {
  },
  created() {
    this.start()
  },
  beforeDestroy() {
    // 清除定时器
    this.end()
  },
  methods: {
    start() {
      // 限免 和 收藏里面才有倒计时
      const endattr = {limitfree: 'promotion_expiredate', collect: 'promotion_enddate'}[this.type]
      if (!this.timer && endattr) {
        const func = () => {
          const now = parseInt(new Date().getTime() / 1000)
          this.data.forEach(item => {
            // 收藏列表里的 没有促销信息的 肯定没有倒计时
            if (this.type === 'collect' && !item.is_promotion) return
            const end = item[endattr]
            const s = end - now
            // alert(s)
            if (s > 0) {
              this.$set(item, 'remaining', getRemaining(s))
            } else {
              this.$set(item, 'remaining', '已过期')
            }
          })
        }
        func()
        this.timer = setInterval(func, 1000)
      }
    },
    end() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    go(cert) {
      this.$router.push({
        path: '/personal/certification/share',
        query: {
          url: cert
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .border-bottom{
    &:last-child{
      &:before{
        display none
      }
    }
  }
  .card-wrap{
    padding size(34) 0
    display flex
  }
  .left{
    width percentage(150/690)
    height size(176)
    border-radius 4px
    overflow hidden
    img{
      display block
      width 100%
      height 100%
    }
  }
  .right{
    width percentage((690 - 150)/690)
    padding-left size(22)
    position relative
    .title{
      width 100%
      font-size size(32)
      // font-weight 800
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      padding-right size(120)
      position relative
      line-height 1.1
      .browser{
        color #8a8a8a
        font-size size(18)
        position absolute
        right 0
        top 50%
        font-weight 500
        margin-top size(-9)
        &.cert{
          color #2bbe87
        }
      }
    }
    .teacher{
      font-size size(24)
      color #8a8a8a
      padding-top  size(20)
      padding-bottom size(20)
    }
    .label{
      font-size 0
      height 16px
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      span{
        display inline-block
        background $color-light
        color #fff
        font-size 10px
        padding size(0) size(8)
        line-height 17px
        height 16px
        border-radius 2px
        margin-right size(8)
      }
    }
    .countdown{
      font-size size(22)
      color $color-light
      margin-top size(20)
    }
    .price{
      position absolute
      right size(8)
      bottom size(24)
      .origin{
        color #b2b2b2
        font-size size(18)
        s{
          font-size size(22)
        }
      }
      .now{
        color $color-light
        font-size size(30)
        font-weight 800
        span{
          font-size size(18)
          position relative
          top size(-10)
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/mycourse/card.vue